import Highlight from "../components/Highlight";
import Form from "../components/Form";

const Contacts = () => {
  return (
    <>
      <Highlight img="about" size="small" />
      <div className="flex py-8 px-14 gap-8">
        <div>
          <iframe
            title="location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3007.806546489787!2d-8.654404284506553!3d41.07322112337456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd247a7c5126c367%3A0xebf6bc47e20f18a3!2sOne%20Idea%20Multiple%20Solutions!5e0!3m2!1spt-PT!2spt!4v1674858197735!5m2!1spt-PT!2spt"
            width="400"
            height="450"
            style={{ border: "0" }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div className="divide-y">
          <div className=" leading-loose">
            <h2 className="text-2xl font-bold mb-4">Fale conosco</h2>
            <p className="text-gray-500 mb-6">
              Seja para tirar dúvidas sobre nossos produtos ou serviços, obter
              assistência com um pedido ou apenas para nos cumprimentar, nossa
              equipe está aqui para ajudar. Utilize o formulário abaixo para
              entrar em contato conosco e retornaremos assim que possível.
              Estamos ansiosos para ouvir você!
            </p>
          </div>

          <div className="flex divide-x width-full">
            <div className="flex flex-col p-6 justify-around items-start text-sm">
              <div className="flex gap-4 items-center justify-center text-gray-500">
                <div className="border-2 rounded-full h-10 w-10 flex items-center justify-center border-gray-300 text-gray-300">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="h-5 w-5"
                  >
                    <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
                    <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
                  </svg>
                </div>
                <div className="text-gray-500 leading-loose">
                  Rua Padre António Vieira, 113
                  <br />
                  4405-679 Vila Nova de Gaia
                  <br />
                  Porto, Portugal
                </div>
              </div>

              <div className="flex gap-4 items-center justify-center text-gray-500">
                <div className="border-2 rounded-full h-10 w-10 flex items-center justify-center border-gray-300 text-gray-300">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="h-5 w-5"
                  >
                    <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                    <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                  </svg>
                </div>
                <div className="text-gray-500 leading-loose">
                  <a href="mailto:comercial@one-idea.pt" className="hover:underline">
                    comercial@one-idea.pt
                  </a>
                  <br />
                  <a href="mailto:iot@one-idea.pt" className="hover:underline">iot@one-idea.pt</a>
                </div>
              </div>

              <div className="flex gap-4 items-center justify-center text-gray-500">
                <div className="border-2 rounded-full h-10 w-10 flex items-center justify-center border-gray-300 text-gray-300">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="h-5 w-5"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div className="text-gray-500 leading-loose">
                  <a href="tel:+351 967 096 454" className="hover:underline">+351 967 096 454</a>
                </div>
              </div>
            </div>

            <div className="p-8 flex-1">
              <Form />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contacts;
